module.exports = __webpack_public_path__ + "img/wirelessAccessPointController2.04e0136c.png";